import { useCallback, useMemo } from 'react';
import { Confirm, Modal, useModal } from '../modals';

export interface IAlert {
  children: React.ReactNode;
  onClose: () => void;
  title?: string;
}

export const AlertModal = ({ children, onClose, title }: IAlert) => {
  const { hide, ...modalProps } = useModal({
    isDefaultOpen: true,
    onExited: onClose,
  });

  return (
    <Modal
      {...modalProps}
      sx={useMemo(
        () => ({
          '.modal__content .confirm__content': {
            overflow: 'visible',
          },
        }),
        [],
      )}
      initialFocusGetter={useCallback((ref: HTMLElement) => {
        return ref?.querySelector('.confirm__confirmButton') as HTMLElement;
      }, [])}
      title={title}
    >
      <Confirm
        onConfirm={useCallback(() => {
          hide();
        }, [hide])}
      >
        {children}
      </Confirm>
    </Modal>
  );
};
